<template>
	<div class="ew-datepicker">
		<div class="input-container">
			<input
				type="text"
				:value="inputDate"
				class="ew-datepicker-input form-control"
				ref="input"
				placeholder="dd/mm/yyyy"
				:required="required"
				@change="onInputChange"
			/>
			<div class="ew-datepicker-toggle" @click="onClickToggle">
				<img :src="images.arrowDown" />
			</div>
		</div>
		<transition name="fade">
			<v-date-picker v-if="showPicker" v-model="picker" @change="onPickerChange"></v-date-picker>
		</transition>
	</div>
</template>

<script>
import moment from 'moment';
import arrowDown from '@/assets/images/arrow-down.svg';

export default {
	props: {
		value: {
			type: String,
			default: '',
		},
		required: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		inputDate() {
			return this.value ? moment(this.value).format('DD/MM/YYYY') : '';
		},
		pickerDate() {
			return this.value ? moment(this.value).format('YYYY-MM-DD') : '';
		},
	},
	data() {
		return {
			picker: new Date().toISOString().substr(0, 10),
			showPicker: false,
			images: {
				arrowDown,
			},
		};
	},
	methods: {
		onClickToggle() {
			this.showPicker = !this.showPicker;
			if (this.showPicker) {
				this.picker = this.pickerDate || new Date().toISOString().substr(0, 10);
			}
		},
		onInputChange() {
			const date = moment(this.$refs.input.value, 'DD/MM/YYYY');
			if (date.isValid()) {
				this.picker = date.format('YYYY-MM-DD');
				this.$emit('input', date.toISOString());
			} else {
				this.$refs.input.value = '';
				this.$emit('input', '');
			}
		},
		onPickerChange() {
			this.showPicker = false;
			const returns = new Date(this.picker).toISOString();
			this.$emit('input', returns);
		},
	},
};
</script>

<style lang="scss">
.ew-datepicker {
	.input-container {
		display: flex;
	}

	.ew-datepicker-input {
		background-color: #fff;
		border: 1px solid #b9b9b9;
		color: #000;
		flex: 1 1 auto;
	}

	.ew-datepicker-toggle {
		background-color: #1da1f2;
		width: 40px;
		text-align: center;
		flex: 0 0 auto;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;

		img {
			width: 12px;
		}
	}
}
</style>
